(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-design-pdp"]) return;
  try {
    
  /* PDP star field */
  (function() {
    var container = document.getElementById('wc-pdp-stars');
    if (!container) return;
    /* Same star array as the homepage hero (walfredo-poster-hero.liquid) */
    var stars = [
      [8,14,1.5,.40,.78],[20,8,1.0,.30,.62],[32,18,2.0,.55,.90],[45,10,1.0,.35,.68],
      [58,6,1.5,.45,.80],[70,12,1.0,.30,.62],[82,8,2.0,.60,.92],[90,16,1.5,.40,.72],
      [15,28,1.0,.28,.55],[27,22,1.5,.42,.78],[40,30,2.0,.58,.92],[53,25,1.0,.30,.58],
      [65,28,1.5,.45,.80],[77,20,1.0,.32,.60],[88,26,2.5,.65,1.0],[96,22,1.0,.28,.55],
      [6,42,1.5,.40,.72],[19,36,1.0,.32,.60],[34,44,2.0,.52,.88],[48,38,1.0,.28,.55],
      [62,42,1.5,.44,.78],[74,36,1.0,.30,.58],[86,44,2.0,.56,.90],[94,40,1.5,.42,.74],
    ];
    var frag = document.createDocumentFragment();
    stars.forEach(function(s) {
      var el = document.createElement('div');
      el.className = 'wc-pdp-star';
      var dur   = (2.2 + Math.random() * 3.0).toFixed(2);
      var delay = (Math.random() * 5.0).toFixed(2);
      el.style.cssText = 'left:'+s[0]+'%;top:'+s[1]+'%;width:'+s[2]+'px;height:'+s[2]+'px;--lo:'+s[3]+';--hi:'+s[4]+';--dur:'+dur+'s;--delay:'+delay+'s';
      frag.appendChild(el);
    });
    container.appendChild(frag);
  })();

  /* Drifting balloons — port of the homepage engine: side-gutter spawns,
     rise + sine sway, fade at the top, no-overlap spacing (spawn retries,
     spawn push-down, in-flight trailing), scroll speed boost. */
  (function() {
    var bg = document.querySelector('.walfredo-pdp-hero-bg');
    var layer = document.getElementById('wc-pdp-balloons');
    if (!bg || !layer) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sprite = layer.getAttribute('data-sprite');
    if (!sprite) return;
    var SPRITES = [
      sprite,
      layer.getAttribute('data-sprite-red') || sprite,
      layer.getAttribute('data-sprite-lime') || sprite,
      layer.getAttribute('data-sprite-orange') || sprite,
      layer.getAttribute('data-sprite-yellow') || sprite
    ];
    var mobile = window.matchMedia('(max-width: 960px)').matches;
    var COUNT = mobile ? 2 : 3;
    var balloons = [];
    var scrollBoost = 0;
    var lastScrollY = window.pageYOffset;
    /* cache backdrop dimensions — reading clientWidth/Height every frame
       forces layout; refresh only on resize and when the loop (re)starts */
    var bgW = bg.clientWidth, bgH = bg.clientHeight;
    function measureBg() { bgW = bg.clientWidth; bgH = bg.clientHeight; }
    window.addEventListener('resize', measureBg);

    function xOverlaps(a, b) {
      return Math.abs(a.x - b.x) < (a.size + b.size) / 2 + a.swayAmp + b.swayAmp;
    }

    function spawn(b, initial) {
      var W = bgW, H = bgH;
      var band = 0.12;
      b.size = (mobile ? 22 : 26) + Math.random() * (mobile ? 10 : 14);
      b.v = 9 + Math.random() * 8;
      b.swayAmp = 6 + Math.random() * 10;
      b.phase = Math.random() * Math.PI * 2;
      var fx;
      for (var t = 0; t < 8; t++) {
        fx = b.side === 0 ? Math.random() * band : 1 - band + Math.random() * band;
        b.x = fx * (W - b.size);
        var clear = true;
        for (var j = 0; j < balloons.length; j++) {
          if (balloons[j] !== b && xOverlaps(b, balloons[j])) { clear = false; break; }
        }
        if (clear) break;
      }
      b.y = initial ? Math.random() * H : H + b.size + Math.random() * H * 0.5;
      /* +1 overshoot is load-bearing: a bare `o.y + b.size * 2.0` can round
         DOWN in float64, leaving |o.y - b.y| still < size*2 with Math.max
         making no progress — an infinite-loop fixed point that hard-locked
         the tab (same bug as the hero balloons, fixed 2026-07-10). Pass cap
         = backstop: N balloons need <= N pushes. */
      var moved = true, passes = 0;
      while (moved && passes++ < 8) {
        moved = false;
        for (var k = 0; k < balloons.length; k++) {
          var o = balloons[k];
          if (o !== b && xOverlaps(b, o) && Math.abs(o.y - b.y) < b.size * 2.0) {
            b.y = Math.max(b.y, o.y + b.size * 2.0 + 1);
            moved = true;
          }
        }
      }
      b.el.style.width = Math.round(b.size) + 'px';
      b.el.style.backgroundImage = "url('" + SPRITES[Math.floor(Math.random() * SPRITES.length)] + "')";
      b.el.style.animationDuration = (2 + Math.random() * 1.3).toFixed(2) + 's';
    }

    for (var i = 0; i < COUNT; i++) {
      var el = document.createElement('div');
      el.className = 'wc-pdp-balloon';
      layer.appendChild(el);
      balloons.push({ el: el, side: i % 2 });
    }
    balloons.forEach(function(b) { spawn(b, true); });

    window.addEventListener('scroll', function() {
      var y = window.pageYOffset;
      scrollBoost = Math.min(240, scrollBoost + Math.abs(y - lastScrollY) * 2);
      lastScrollY = y;
    }, { passive: true });

    var last = 0;
    function tick(now) {
      if (!last) last = now;
      var dt = Math.min(0.1, (now - last) / 1000);
      last = now;
      var H = bgH;
      scrollBoost *= Math.pow(0.1, dt);
      balloons.sort(function(a, b) { return a.y - b.y; });
      for (var i = 0; i < balloons.length; i++) {
        var b = balloons[i], v = b.v;
        for (var j = i - 1; j >= 0; j--) {
          if (xOverlaps(b, balloons[j])) {
            if (b.y - balloons[j].y < b.size * 2.0) v = Math.min(v, balloons[j].vEff);
            break;
          }
        }
        b.vEff = v;
        b.y -= (v + scrollBoost) * dt;
        if (b.y < -b.size * 1.6) { spawn(b, false); }
        var fadeTop = 55; /* quick fade only right at the top edge */
        var op = 1;
        if (b.y < fadeTop) op = b.y / fadeTop;
        /* Fade in over the balloon's own height so it only reaches full
           opacity once fully emerged above the clip line (H). Prevents a
           fully-opaque balloon showing while its bottom half is still
           clipped behind the white shop card's top edge. */
        op = Math.min(op, (H - b.y) / b.size);
        op = Math.max(0, Math.min(1, op));
        var sx = Math.sin(b.phase + b.y / 55) * b.swayAmp;
        b.el.style.opacity = op.toFixed(3);
        b.el.style.transform = 'translate3d(' + (b.x + sx).toFixed(1) + 'px,' + b.y.toFixed(1) + 'px,0)';
      }
      if (running && bg.isConnected) requestAnimationFrame(tick);
    }
    /* run only while the hero backdrop is on screen — the loop idles once
       the user scrolls past it (and stops for good if the section DOM is
       replaced, e.g. in the theme editor) */
    var running = false;
    var io = new IntersectionObserver(function(entries) {
      /* last entry, not [0]: IO batches multiple crossings per delivery */
      if (entries[entries.length - 1].isIntersecting) {
        if (!running) { running = true; last = 0; measureBg(); requestAnimationFrame(tick); }
      } else {
        running = false;
      }
    });
    io.observe(bg);
  })();

  /* Cloud breeze — port of the homepage hero engine: left-to-right drift
     across the min(100vw, 1920px) corridor with in-flight edge fades,
     parallax speeds (near = faster), trailing + wrap-wait spacing so clouds
     never bunch, and a wider berth between vertically-close NEAR clouds.
     No JS / reduced motion = the static designed cloud layout. */
  (function() {
    var bg = document.querySelector('.walfredo-pdp-hero-bg');
    if (!bg || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var SPEEDS  = { cl: 15, cl2: 7.5, cu: 8, cu2: 7, ru: 8, rf: 13, bl: 20 }; /* px/s */
    var FLIPPED = { cl2: 1, cu2: 1, rf: 1 };
    var FADE = 120, MIN_GAP = 110;
    var NEAR_OP = 0.6;
    var NEAR_VDIST = 280;
    function nearGap() {
      return Math.max(180, Math.min(300, (corridorR - corridorL) * 0.2));
    }
    var clouds = [], corridorL = 0, corridorR = 0, last = 0;

    function measure(keepProgress) {
      var bgW = bg.clientWidth;
      if (!bgW) return false;
      /* layout viewport, not innerWidth: an iOS pinch zoom shrinks innerWidth
         (and fires resize), which squeezed every cloud into a narrower corridor */
      var W = Math.min(document.documentElement.clientWidth, 1920);
      var newL = (bgW - W) / 2, newR = newL + W;
      var els = bg.querySelectorAll('.wc-pdp-cloud');
      var next = [];
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var key = (el.className.match(/cloud--(\w+)/) || [])[1];
        if (!key || !el.offsetWidth) continue;
        var prev = null;
        for (var j = 0; j < clouds.length; j++) if (clouds[j].el === el) prev = clouds[j];
        var c = {
          el: el, key: key,
          v: SPEEDS[key] || 10,
          w: el.offsetWidth, h: el.offsetHeight,
          top: el.offsetTop,
          staticX: el.offsetLeft,
          baseOp: parseFloat(getComputedStyle(el).opacity) || 1
        };
        c.near = c.baseOp >= NEAR_OP;
        if (keepProgress && prev) {
          var f = (prev.x - corridorL) / (corridorR - corridorL || 1);
          c.x = newL + f * (newR - newL);
          c.baseOp = prev.baseOp;
          c.near = prev.near;
        } else {
          c.x = c.staticX;
          /* don't start overlapping the front (card) cloud — shift left
             until clear; speeds differ so later passes may still meet */
          var fc = document.querySelector('.wc-pdp-cloud-front');
          if (fc && fc.offsetWidth) {
            var fr = fc.getBoundingClientRect(), br = bg.getBoundingClientRect();
            var fx = fr.left - br.left, fy = fr.top - br.top;
            if (c.top < fy + fr.height && c.top + c.h > fy &&
                c.x < fx + fr.width + 40 && c.x + c.w > fx - 40) {
              c.x = fx - c.w - 60;
            }
          }
        }
        next.push(c);
      }
      corridorL = newL; corridorR = newR; clouds = next;
      return clouds.length > 0;
    }

    function bandOverlap(a, b) {
      return a.top < b.top + b.h && a.top + a.h > b.top;
    }
    function interacts(a, b) {
      if (bandOverlap(a, b)) return true;
      return a.near && b.near &&
        Math.abs((a.top + a.h / 2) - (b.top + b.h / 2)) < NEAR_VDIST;
    }
    function gapFor(a, b) {
      return a.near && b.near ? nearGap() : MIN_GAP;
    }

    function tick(now) {
      if (!last) last = now;
      var dt = Math.min(0.1, (now - last) / 1000);
      last = now;
      clouds.sort(function(a, b) { return b.x - a.x; });
      for (var i = 0; i < clouds.length; i++) {
        var c = clouds[i], v = c.v;
        for (var j = i - 1; j >= 0; j--) {
          if (interacts(c, clouds[j])) {
            if (clouds[j].x - (c.x + c.w) < gapFor(c, clouds[j])) v = Math.min(v, clouds[j].vEff);
            break;
          }
        }
        c.vEff = v;
        var nx = c.x + v * dt;
        if (nx > corridorR) {
          var candidate = corridorL - c.w, clear = true;
          for (var k = 0; k < clouds.length; k++) {
            var o = clouds[k];
            if (o !== c && interacts(c, o) && o.x < candidate + c.w + gapFor(c, o)) { clear = false; break; }
          }
          nx = clear ? candidate : corridorR;
        }
        c.x = nx;
        var op = Math.max(0, Math.min(1, (c.x + c.w - corridorL) / FADE, (corridorR - c.x) / FADE));
        c.el.style.opacity = (c.baseOp * op).toFixed(3);
        c.el.style.transform = 'translateX(' + (c.x - c.staticX).toFixed(1) + 'px)' + (FLIPPED[c.key] ? ' scaleX(-1)' : '');
      }
      if (running && bg.isConnected) requestAnimationFrame(tick);
    }

    /* drift only while the hero backdrop is on screen; measure() may fail
       before first layout (zero width) — retry while visible */
    var running = false, visible = false, measured = false;
    function startIfReady() {
      if (!visible) return;
      if (!measured) {
        measured = measure(false);
        if (!measured) { setTimeout(startIfReady, 800); return; }
      }
      if (!running) { running = true; last = 0; requestAnimationFrame(tick); }
    }
    var io = new IntersectionObserver(function(entries) {
      /* last entry, not [0]: IO batches multiple crossings per delivery */
      visible = entries[entries.length - 1].isIntersecting;
      if (visible) startIfReady();
      else running = false;
    });
    io.observe(bg);
    /* offsetHeight is 0 at the load event (layout hasn't run) — retry
       until every cloud has real height or band detection stays dead */
    var heightTries = 0;
    function ensureHeights() {
      measure(true);
      var ok = clouds.length && clouds.every(function(c) { return c.h > 0; });
      if (!ok && ++heightTries < 20) setTimeout(ensureHeights, 400);
    }
    window.addEventListener('load', function() { requestAnimationFrame(ensureHeights); });
    window.addEventListener('resize', function() { measure(true); });
  })();

  /* "Find this design in the poster" — resolve the deep link from the same
     hotspots data the explorer uses. Auto-appears for any design that has a
     matching poster spot; stays hidden otherwise. No per-design manual step. */
  (function () {
    var links = document.querySelectorAll('[data-pdp-poster-link]');
    if (!links.length) return;

    /* Per-design lens-peek tuning. The map PIN is placed where the node sits
       on the explorer (often near the TOP of a character so the pin points at
       its head/label), but the PDP lens wants the character CENTERED. Nudge
       the peek focus per design without moving the pin:
         dy  = shift focus DOWN the poster in native px (slides the art UP in
               the lens); negative = up.
         dx  = shift focus RIGHT in native px; negative = left.
         win = override the 420px crop size (smaller = tighter zoom).
       Key by hotspot slug (preferred) or design handle. Add an entry per
       design as new designs go live. */
    var PEEK_OVERRIDES = {
      // Node sits on the driver's head; recenter the lens on the figure's body.
      driver: { dy: 290 }
    };

    function handleize(s) {
      return String(s).toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    links.forEach(function (el) {
      fetch(el.dataset.hotspotsUrl).then(function (r) { return r.json(); }).then(function (data) {
        var keys = [el.dataset.designHandle, handleize(el.dataset.designName)];
        /* a hotspot tagged with the design handle wins over a slug match:
           a name can have several finds (Halley's Comet has three) */
        var items = data.items || [];
        var hit = items.find(function (it) { return keys.indexOf(it.design) !== -1; }) ||
                  items.find(function (it) { return keys.indexOf(it.slug) !== -1; });
        if (hit) {
          el.href = el.dataset.posterUrl + '#find=' + hit.slug;
          /* stat row: category + find number, e.g. "Songs · No. 73B" */
          var cat = (data.categories || []).find(function (c) { return c.key === hit.cat; }) || {};
          var SHORT = { songs: 'Song', albums: 'Album cover', gamehendge: 'Gamehendge', events: 'Event', festivals: 'Festival', donuts: "Baker's Dozen donut", musicians: 'Musician', bandcrew: 'Band & crew', phriends: 'Phriend', eggs: 'Easter egg' };
          var label = SHORT[hit.cat] || cat.title || 'Find';
          /* songs: say original or cover (per-design, from the section) */
          var kind = document.querySelector('[data-song-kind]');
          if (hit.cat === 'songs' && kind && kind.dataset.songKind) label = kind.dataset.songKind;
          document.querySelectorAll('[data-pdp-poster-fact]').forEach(function (row) {
            var t = row.querySelector('[data-pdp-poster-fact-text]');
            var a = row.querySelector('[data-pdp-poster-fact-link]');
            var d = row.querySelector('[data-pdp-poster-fact-dot]');
            if (t) t.textContent = label + ' \u00b7 No. ' + hit.num + (hit.var || '');
            if (a) a.href = el.dataset.posterUrl + '#find=' + hit.slug;
            if (d && cat.color) d.style.setProperty('--cat', cat.color);
            row.hidden = false;
          });
          // aim the finder lens at the actual spot on the poster — a ~420
          // native-px window around the find, as a tease of where it hides
          var peek = el.querySelector('[data-lens-peek]');
          if (peek && el.dataset.previewUrl && data.w && data.h) {
            var ov = PEEK_OVERRIDES[hit.slug] || PEEK_OVERRIDES[el.dataset.designHandle] || {};
            var win = ov.win || 420;
            var fx = hit.x + (ov.dx || 0);
            var fy = hit.y + (ov.dy || 0);
            var px = Math.max(0, Math.min(100, ((fx - win / 2) / (data.w - win)) * 100));
            var py = Math.max(0, Math.min(100, ((fy - win / 2) / (data.h - win)) * 100));
            peek.style.backgroundImage = 'url("' + el.dataset.previewUrl + '")';
            peek.style.backgroundSize = (data.w / win) * 100 + '% auto';
            peek.style.backgroundPosition = px + '% ' + py + '%';
          }
          el.hidden = false;
        }
      }).catch(function () {});
    });
  })();

  /* Share — navigator.share with clipboard fallback + toast
     (same pattern as doShare in walfredo-poster-explorer.js). */
  (function () {
    var btn = document.querySelector('[data-pdp-share]');
    if (!btn) return;
    var toastEl = document.querySelector('[data-pdp-share-toast]');
    var toastTimer;
    function toast(msg, ms) {
      if (!toastEl) return;
      toastEl.textContent = msg;
      toastEl.hidden = false;
      requestAnimationFrame(function () { toastEl.classList.add('is-in'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toastEl.classList.remove('is-in');
        setTimeout(function () { toastEl.hidden = true; }, 220);
      }, ms || 2200);
    }
    btn.addEventListener('click', function () {
      var text = btn.getAttribute('data-share-text') || '';
      var url = btn.getAttribute('data-share-url') || window.location.href;
      if (navigator.share) {
        navigator.share({ text: text, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(text + ' ' + url).then(function () {
          toast('Copied to clipboard. Paste it anywhere.', 2200);
        });
      }
    });
  })();

  /* Lineup strip — arrows page the rail; the rail opens with the current
     design centered (instant, not smooth, so the page doesn't animate on load). */
  (function () {
    var rail = document.querySelector('[data-crew-rail]');
    if (!rail) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-crew-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        rail.scrollBy({
          left: Math.round(rail.clientWidth * 0.7) * Number(btn.getAttribute('data-crew-scroll')),
          behavior: reduced ? 'auto' : 'smooth'
        });
      });
    });
    var here = rail.querySelector('.wc-crew__item--here');
    if (here) rail.scrollLeft = here.offsetLeft - rail.clientWidth / 2 + here.offsetWidth / 2;
  })();

  /* Lineup dock magnification — macOS-dock style: the coin under the cursor
     swells and its neighbors swell proportionally with a smoothstep falloff,
     all growing upward from the name line (transform-origin is the coin's
     bottom). Fine pointers only; touch keeps the plain swipe strip and
     reduced-motion users keep the CSS pluck. */
  (function () {
    var rail = document.querySelector('[data-crew-rail]');
    if (!rail) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var RANGE = 130;  /* px from cursor at which a coin stops responding */
    var BOOST = 0.28; /* max extra scale on the coin dead under the cursor */

    var items = Array.prototype.slice.call(rail.querySelectorAll('.wc-crew__item'));
    var coins = items.map(function (it) { return it.querySelector('.wc-crew__coin'); });
    var mouseX = null;
    var raf = null;

    function paint() {
      raf = null;
      for (var i = 0; i < items.length; i++) {
        if (!coins[i]) continue;
        var s = 1;
        if (mouseX !== null) {
          var r = items[i].getBoundingClientRect();
          var d = Math.abs(mouseX - (r.left + r.width / 2));
          var t = Math.max(0, 1 - d / RANGE);
          t = t * t * (3 - 2 * t); /* smoothstep */
          s = 1 + BOOST * t;
        }
        if (s > 1.005) {
          coins[i].style.transform = 'scale(' + s.toFixed(3) + ')';
          items[i].style.zIndex = '3';
        } else {
          coins[i].style.transform = '';
          items[i].style.zIndex = '';
        }
      }
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(paint); }
    rail.addEventListener('mousemove', function (e) { mouseX = e.clientX; schedule(); });
    rail.addEventListener('mouseleave', function () { mouseX = null; schedule(); });
    rail.addEventListener('scroll', function () { if (mouseX !== null) schedule(); }, { passive: true });
  })();

  /* Character profile hero: the name fitter, and the fixed-height sky
     backdrop stretched to the shop card's top so stars/balloons cover the
     whole hero. */
  (function () {
    var section = document.querySelector('[data-design-pdp]');
    var stage = document.querySelector('[data-pdp-stage]');
    if (!section || !stage) return;

    /* (The single-line name fitter runs inline right after the <h1> so the
       name is sized before first paint — see the markup.) */

    /* Roster strip: when every coin fits it's a plain centred row (.is-static:
       no arrows, no faded ends); when they overflow it scrolls, opens with the
       current design centred, and the arrows page. Re-checked on resize. */
    var rosterRail = section.querySelector('[data-roster-rail]');
    var roster = section.querySelector('[data-pdp-roster]');
    if (rosterRail && roster) {
      var here = rosterRail.querySelector('.wc-crew__item--here');
      var lastW = 0;
      var fitRoster = function () {
        var w = roster.clientWidth;
        if (!w || w === lastW) return;
        lastW = w;
        roster.classList.add('is-static');   /* measure with the arrows out of the way */
        var fits = rosterRail.scrollWidth <= rosterRail.clientWidth + 1;
        roster.classList.toggle('is-static', fits);
        if (fits) rosterRail.scrollLeft = 0;
        else if (here) rosterRail.scrollLeft = here.offsetLeft + here.offsetWidth / 2 - rosterRail.clientWidth / 2;
      };
      fitRoster();
      if ('ResizeObserver' in window) new ResizeObserver(fitRoster).observe(roster);
      else window.addEventListener('resize', fitRoster);
      section.querySelectorAll('[data-roster-scroll]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          rosterRail.scrollBy({ left: parseInt(btn.dataset.rosterScroll, 10) * rosterRail.clientWidth * 0.7, behavior: 'smooth' });
        });
      });
    }

    var bg = section.querySelector('.walfredo-pdp-hero-bg');
    var shop = section.querySelector('.walfredo-design-pdp__shop');
    if (!bg || !shop) return;
    function sizeSky() {
      var top = shop.getBoundingClientRect().top - section.getBoundingClientRect().top;
      if (top > 0) bg.style.height = Math.round(top + 24) + 'px';
    }
    sizeSky();
    window.addEventListener('resize', sizeSky);
    window.addEventListener('load', sizeSky);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["walfredo-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  const form = document.querySelector('[data-contact-form]');
  if (!form) return;

  const id = form.dataset.contactForm;

  const FIELDS = [
    { suffix: 'name',    msg: 'Please enter your name.' },
    { suffix: 'email',   msg: 'Please enter a valid email address.' },
    { suffix: 'subject', msg: 'Please enter a subject.' },
    { suffix: 'body',    msg: 'Please enter your message.' },
  ];

  function getEl(field)  { return document.getElementById(id + '-' + field.suffix); }
  function getErr(field) { return document.getElementById(id + '-' + field.suffix + '-error'); }

  function isValid(field) {
    const el = getEl(field);
    if (!el) return true;
    if (el.type === 'email') return el.value.trim() !== '' && el.checkValidity();
    return el.value.trim() !== '';
  }

  function showError(field) {
    const el = getEl(field);
    const err = getErr(field);
    if (!el || !err) return;
    err.textContent = field.msg;
    el.setAttribute('aria-invalid', 'true');
  }

  function clearError(field) {
    const el = getEl(field);
    const err = getErr(field);
    if (!el || !err) return;
    err.textContent = '';
    el.removeAttribute('aria-invalid');
  }

  FIELDS.forEach(function (field) {
    const el = getEl(field);
    if (!el) return;
    el.addEventListener('blur', function () {
      if (!isValid(field)) showError(field); else clearError(field);
    });
    el.addEventListener('input', function () { clearError(field); });
  });

  form.addEventListener('submit', function (e) {
    let firstInvalid = null;
    FIELDS.forEach(function (field) {
      if (!isValid(field)) {
        showError(field);
        if (!firstInvalid) firstInvalid = getEl(field);
      } else {
        clearError(field);
      }
    });
    if (firstInvalid) {
      e.preventDefault();
      // Also stop the event from reaching document: Shopify's captcha
      // bootstrap listens there and force-resubmits /contact forms via
      // form.submit() without checking defaultPrevented.
      e.stopPropagation();
      firstInvalid.focus();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["walfredo-footer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.location.search.includes('customer_posted=true')) {
      var url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      window.history.replaceState({}, '', url.toString());
    }

    var form = document.querySelector('.walfredo-footer__form');
    if (!form) return;

    // Block any programmatic form.submit() calls from Shopify's JS
    form.submit = function() {};

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var btn = form.querySelector('.walfredo-footer__submit');
      if (btn) btn.disabled = true;

      var action = form.getAttribute('action').split('#')[0];

      fetch(action, { method: 'POST', body: new FormData(form) })
        .then(function(res) {
          if (res.url && res.url.includes('customer_posted=true')) {
            var disclaimer = form.nextElementSibling;
            var success = document.createElement('p');
            success.className = 'walfredo-footer__success';
            success.textContent = "You're in! We'll be in touch.";
            form.parentNode.insertBefore(success, form);
            form.style.display = 'none';
            if (disclaimer && disclaimer.classList.contains('walfredo-footer__disclaimer')) {
              disclaimer.style.display = 'none';
            }
          } else {
            if (btn) btn.disabled = false;
          }
        })
        .catch(function() {
          if (btn) btn.disabled = false;
        });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["walfredo-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const drawer = document.querySelector('#Details-menu-drawer-container');
    if (!drawer) return;

    let closeTimer = null;
    const CLOSE_MS = 240; // must match the menu-drawer transition duration
    const setOpen = (open) => {
      if (open) {
        clearTimeout(closeTimer);
        drawer.classList.remove('is-closing');
        drawer.setAttribute('open', '');
        document.body.style.overflow = 'hidden';
      } else if (drawer.hasAttribute('open')) {
        // slide the drawer out FIRST, then collapse the <details> — removing `open`
        // immediately would display-hide the content and skip the exit animation
        drawer.classList.add('is-closing');
        document.body.style.overflow = '';
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          drawer.removeAttribute('open');
          drawer.classList.remove('is-closing');
        }, CLOSE_MS);
      }
      document.querySelectorAll('[data-walfredo-header-toggle]').forEach((btn) => {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    };

    document.querySelectorAll('[data-walfredo-header-toggle]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        setOpen(!drawer.hasAttribute('open'));
      });
    });

    document.querySelectorAll('[data-walfredo-drawer-close]').forEach((btn) => {
      btn.addEventListener('click', () => setOpen(false));
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.hasAttribute('open')) setOpen(false);
    });

    drawer.querySelectorAll('a[href]').forEach((link) => {
      link.addEventListener('click', () => setOpen(false));
    });

    // Close when resizing to desktop (hamburger is hidden ≥769px)
    const mq = window.matchMedia('(min-width: 769px)');
    mq.addEventListener('change', (e) => {
      if (e.matches && drawer.hasAttribute('open')) setOpen(false);
    });
  })();

  (function () {
    var badge = document.getElementById('walfredo-cart-count');
    var link = document.getElementById('walfredo-cart-link');
    if (!badge) return;

    document.addEventListener('cart:update', function (event) {
      var count = event.detail?.data?.itemCount ?? event.detail?.resource?.item_count ?? 0;
      badge.textContent = count;
      badge.classList.toggle('hidden', count === 0);
      if (link) link.setAttribute('aria-label', 'Cart, ' + count + ' items');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["walfredo-poster-hero"] && !Shopify.designMode) return;
  try {
    
  /* ── Back/forward-cache lifecycle ──
     Quiesce every hero animation loop when the page is frozen for the bfcache,
     and restart them clean on restore. WebKit/Safari blocks the main thread
     trying to reconcile a bfcached page full of running rAF loops + a live
     WAAPI animation when you hit Back (reproduced: page restores but hangs,
     can't tap, only compositor CSS keeps moving). Entering bfcache inert and
     restarting on pageshow avoids the lock. Each loop registers a stop/start. */
  var WF_HERO_STOP = [], WF_HERO_START = [], WF_SHED = [];
  var WF_IDLE_FROZEN = false; /* set by the idle-quiesce module; read by the watchdog so idle gaps aren't mis-read as lag */

  window.addEventListener('pagehide', function () {
    for (var i = 0; i < WF_HERO_STOP.length; i++) { try { WF_HERO_STOP[i](); } catch (e) {} }
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return; /* only bfcache restores; a fresh load re-inits anyway */
    for (var i = 0; i < WF_HERO_START.length; i++) { try { WF_HERO_START[i](); } catch (e) {} }
  });

  /* Calm mode: on phones (or reduced-motion) freeze the hero to a static scene.
     iOS Safari accumulates GPU/compositor work from the continuous cast until
     the tab locks, even sitting still — matching the proven-stable reduced-motion
     config is the only reliable fix. Evaluated once; phones don't cross 768px. */
  var WF_CALM = window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
                window.matchMedia('(max-width: 768px)').matches;

  /* Star field */
  (function() {
    var container = document.getElementById('walfredo-hero-stars');
    if (!container) return;
    var stars = [
      [8,14,1.5,.40,.78],[20,8,1.0,.30,.62],[32,18,2.0,.55,.90],[45,10,1.0,.35,.68],
      [58,6,1.5,.45,.80],[70,12,1.0,.30,.62],[82,8,2.0,.60,.92],[90,16,1.5,.40,.72],
      [15,28,1.0,.28,.55],[27,22,1.5,.42,.78],[40,30,2.0,.58,.92],[53,25,1.0,.30,.58],
      [65,28,1.5,.45,.80],[77,20,1.0,.32,.60],[88,26,2.5,.65,1.0],[96,22,1.0,.28,.55],
      [6,42,1.5,.40,.72],[19,36,1.0,.32,.60],[34,44,2.0,.52,.88],[48,38,1.0,.28,.55],
      [62,42,1.5,.44,.78],[74,36,1.0,.30,.58],[86,44,2.0,.56,.90],[94,40,1.5,.42,.74],
      [3,10,1.0,.30,.60],[12,20,1.5,.42,.76],[24,13,1.0,.30,.62],[38,7,1.5,.45,.82],
      [50,16,1.0,.32,.64],[60,10,2.0,.55,.90],[68,20,1.0,.30,.60],[80,14,1.5,.44,.80],
      [92,10,1.0,.30,.58],[10,33,1.0,.30,.60],[22,45,1.5,.40,.74],[36,24,1.0,.32,.62],
      [46,45,1.5,.44,.80],[56,34,1.0,.30,.58],[70,45,2.0,.52,.88],[84,33,1.0,.32,.62],
      [2,26,1.5,.40,.72],[98,32,1.0,.28,.56],[30,4,1.0,.30,.60],[52,4,1.5,.42,.76],
      [5,6,1.0,.30,.60],[16,4,1.5,.42,.76],[42,6,1.0,.32,.62],[54,9,1.5,.45,.80],
      [66,5,1.0,.30,.60],[78,4,2.0,.55,.90],[4,18,1.0,.30,.60],[44,15,1.5,.44,.80],
      [72,26,1.0,.30,.58],[8,39,1.5,.40,.74],[30,41,1.0,.32,.62],[41,20,1.5,.42,.76],
      [58,45,1.0,.30,.58],[90,34,1.5,.44,.80],[26,11,1.0,.30,.60],[64,17,1.5,.42,.78],
    ];
    var frag = document.createDocumentFragment();
    stars.forEach(function(s) {
      var el = document.createElement('div');
      el.className = 'walfredo-hero__star-dot';
      var dur   = (2.2 + Math.random() * 3.0).toFixed(2);
      var delay = (Math.random() * 5.0).toFixed(2);
      el.style.cssText = 'left:'+s[0]+'%;top:'+s[1]+'%;width:'+s[2]+'px;height:'+s[2]+'px;--opacity-lo:'+s[3]+';--opacity-hi:'+s[4]+';--twinkle-dur:'+dur+'s;--twinkle-delay:'+delay+'s';
      frag.appendChild(el);
    });
    container.appendChild(frag);
  })();

  /* Drifting balloons — spawn in the hero's side gutters near the bottom
     edge, rise slowly with a sine sway, fade in entering from below and
     fade out approaching the top edge, then respawn. Page scrolling adds a
     decaying upward speed boost. Colors via hue-rotate tints. No JS /
     reduced motion = the static heart-balloon float instead. */
  (function() {
    var hero = document.querySelector('.walfredo-hero');
    var layer = document.getElementById('walfredo-hero-balloons');
    if (!hero || !layer) return;
    /* Runs on mobile again (2026-07-10, user request) now that the spawn
       fixed-point infinite loop is fixed — the mobile params (COUNT 4, small
       sizes, wide gutters) below were always here for this. Watchdog can
       still shed it. Reduced-motion keeps the static heart-balloon float. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sprite = layer.getAttribute('data-sprite');
    if (!sprite) return;
    var fallback = document.querySelector('.walfredo-hero__float-wrap--heartballoon');
    if (fallback) fallback.style.display = 'none';

    /* baked color-variant sheets — CSS filters can't make a clean red */
    var SPRITES = [
      sprite,
      layer.getAttribute('data-sprite-red') || sprite,
      layer.getAttribute('data-sprite-lime') || sprite,
      layer.getAttribute('data-sprite-orange') || sprite,
      layer.getAttribute('data-sprite-yellow') || sprite
    ];
    var mobile = window.matchMedia('(max-width: 768px)').matches;
    var COUNT = mobile ? 4 : 7; /* desktop raised 5→7 with the wider middle spawn zone */
    var balloons = [];
    var scrollBoost = 0;
    var lastScrollY = window.pageYOffset;
    /* cache hero dimensions — reading clientWidth/Height every frame forces
       layout; refresh only on resize and when the loop (re)starts */
    var heroW = hero.clientWidth, heroH = hero.clientHeight;
    function measureHero() { heroW = hero.clientWidth; heroH = hero.clientHeight; }
    window.addEventListener('resize', measureHero);

    function xOverlaps(a, b) {
      return Math.abs(a.x - b.x) < (a.size + b.size) / 2 + a.swayAmp + b.swayAmp;
    }

    function spawn(b, initial) {
      var band = mobile ? 0.16 : 0.12; /* side gutters of the content area */
      b.size = (mobile ? 24 : 30) + Math.random() * (mobile ? 12 : 18);
      b.v = 8 + Math.random() * 16; /* px/s upward — wide spread so no two balloons climb in lockstep */
      b.swayAmp = 8 + Math.random() * 12;
      b.phase = Math.random() * Math.PI * 2;
      /* pendulum-tilt personality — stiffness/damping/gust vary per balloon
         so the rocking never syncs up across the flock */
      b.spring = 8 + Math.random() * 10;    /* soft spring = lazy, wide swings */
      b.damp = 1.6 + Math.random() * 1.2;   /* underdamped: overshoots + settles */
      b.gustF = 0.25 + Math.random() * 0.5; /* slow random-gust torque, Hz-ish */
      b.gustAmp = 55 + Math.random() * 55;  /* steady-state gust lean ≈ amp/spring, ~4-12deg */
      b.gustPhase = Math.random() * Math.PI * 2;
      b.px = undefined; /* reset lateral-velocity tracking (position jumps on respawn) */
      /* balloons alternate sides; on desktop about half the spawns rise
         through the middle 2/3 of the hero instead (over the art), the rest
         keep to the gutters. Retry x until clear of nearby traffic. */
      var fx;
      for (var t = 0; t < 8; t++) {
        if (!mobile && Math.random() < 0.5) {
          fx = 1 / 6 + Math.random() * (2 / 3);
        } else {
          fx = b.side === 0 ? Math.random() * band : 1 - band + Math.random() * band;
        }
        b.x = fx * (heroW - b.size);
        var clear = true;
        for (var j = 0; j < balloons.length; j++) {
          if (balloons[j] !== b && xOverlaps(b, balloons[j])) { clear = false; break; }
        }
        if (clear) break;
      }
      b.y = initial ? Math.random() * heroH : heroH + b.size + Math.random() * heroH * 0.4;
      /* never spawn overlapping a column-mate: push deeper below the edge.
         The +1 overshoot is load-bearing: with a bare `o.y + b.size * 2.0`
         the float sum can round DOWN, leaving |o.y - b.y| still < size*2
         while Math.max makes no further progress — a fixed point that spun
         this loop forever and hard-locked the tab (~40% of pushes; caught
         live 2026-07-10). Pass cap = backstop: N balloons need <= N pushes. */
      var moved = true, passes = 0;
      while (moved && passes++ < 8) {
        moved = false;
        for (var k = 0; k < balloons.length; k++) {
          var o = balloons[k];
          if (o !== b && xOverlaps(b, o) && Math.abs(o.y - b.y) < b.size * 2.0) {
            b.y = Math.max(b.y, o.y + b.size * 2.0 + 1);
            moved = true;
          }
        }
      }
      b.el.style.width = Math.round(b.size) + 'px';
      b.el.style.backgroundImage = "url('" + SPRITES[Math.floor(Math.random() * SPRITES.length)] + "')";
    }

    for (var i = 0; i < COUNT; i++) {
      var el = document.createElement('div');
      el.className = 'walfredo-hero__balloon';
      layer.appendChild(el);
      var b = { el: el, side: i % 2 };
      balloons.push(b);
    }
    balloons.forEach(function(b) { spawn(b, true); });

    window.addEventListener('scroll', function() {
      var y = window.pageYOffset;
      scrollBoost = Math.min(240, scrollBoost + Math.abs(y - lastScrollY) * 2);
      lastScrollY = y;
    }, { passive: true });

    /* Collision physics: when the wingsuit flyer plows into a balloon, it
       takes an impulse along the contact normal scaled by his speed, drifts
       with drag, tips into the shove, and recovers its gentle rise. */
    var flyerEl = null, flyerPrev = null;
    var fS = { x: null, y: 0, vx: 0, vy: 0, r: 0 }, frameN = 0;
    var last = 0;
    function tick(now) {
      if (!last) last = now;
      var dt = Math.min(0.1, (now - last) / 1000);
      last = now;
      scrollBoost *= Math.pow(0.1, dt); /* fast decay back to calm */

      if (!flyerEl) flyerEl = document.querySelector('.walfredo-hero__flyer');
      /* sample the flyer's rect every 3rd frame — getBoundingClientRect
         forces layout, and a per-frame read thrashes against the style
         writes below (and the cloud engine's) */
      frameN++;
      if (flyerEl && frameN % 3 === 0) {
        var lr = layer.getBoundingClientRect();
        var fr = flyerEl.getBoundingClientRect();
        var sx2 = fr.left - lr.left + fr.width / 2;
        var sy2 = fr.top - lr.top + fr.height / 2;
        if (flyerPrev) {
          var sdt = (now - flyerPrev.t) / 1000;
          if (sdt > 0) { fS.vx = (sx2 - flyerPrev.x) / sdt; fS.vy = (sy2 - flyerPrev.y) / sdt; }
        }
        flyerPrev = { x: sx2, y: sy2, t: now };
        fS.x = sx2; fS.y = sy2; fS.r = fr.width * 0.42;
      }
      var fx = fS.x, fy = fS.y, fvx = fS.vx, fvy = fS.vy, fR = fS.r;

      balloons.sort(function(a, b) { return a.y - b.y; }); /* highest first */
      for (var i = 0; i < balloons.length; i++) {
        var b = balloons[i], v = b.v;
        for (var j = i - 1; j >= 0; j--) { /* nearest column-mate above */
          if (xOverlaps(b, balloons[j])) {
            if (b.y - balloons[j].y < b.size * 2.0) v = Math.min(v, balloons[j].vEff);
            break;
          }
        }
        b.vEff = v;
        b.kvx = b.kvx || 0; b.kvy = b.kvy || 0;

        /* flyer collision — circle vs balloon bulb */
        var sway = Math.sin(b.phase + b.y / 55) * b.swayAmp;
        var bx = b.x + sway + b.size / 2;
        var by = b.y + b.size * 0.47;
        if (fx !== null) {
          var dx = bx - fx, dy = by - fy;
          var dist = Math.sqrt(dx * dx + dy * dy) || 1;
          var minD = fR + b.size * 0.5;
          if (dist < minD) {
            var nx = dx / dist, ny = dy / dist;
            var fSpeed = Math.sqrt(fvx * fvx + fvy * fvy);
            var kick = (minD - dist) * 10 + 90 + fSpeed * 0.45;
            b.kvx += nx * kick * dt * 12;
            b.kvy += ny * kick * dt * 12;
            var kMag = Math.sqrt(b.kvx * b.kvx + b.kvy * b.kvy);
            if (kMag > 520) { b.kvx *= 520 / kMag; b.kvy *= 520 / kMag; }
          }
        }

        /* integrate: rise + scroll boost + decaying impulse (drag) */
        b.x += b.kvx * dt;
        b.y += (b.kvy - v - scrollBoost) * dt;
        var dragF = Math.exp(-2.2 * dt);
        b.kvx *= dragF; b.kvy *= dragF;
        if (b.x < -b.size * 2) b.x = -b.size * 2;
        if (b.x > heroW + b.size) b.x = heroW + b.size;

        if (b.y < -b.size * 1.6 || b.y > heroH * 1.9) { b.kvx = b.kvy = 0; spawn(b, false); }
        var fadeTop = 60; /* quick fade only right at the top edge */
        var op = 1;
        if (b.y < fadeTop) op = b.y / fadeTop; /* fade out toward the top edge */
        op = Math.min(op, (heroH + b.size - b.y) / 55); /* quick fade-in entering */
        op = Math.max(0, Math.min(1, op));
        /* Tilt — damped-spring pendulum rather than a rigid position lean:
           the bulb leans into its lateral velocity (air drag as it's carried
           sideways by sway + collision kicks), overshoots, and wobbles back;
           a slow per-balloon gust torque keeps it irregular. A few mults per
           frame — no layout reads, so effectively free. */
        var lx = b.x + sway;
        if (b.px === undefined) { b.px = lx; b.tilt = 0; b.tiltV = 0; }
        var latV = dt > 0 ? Math.max(-160, Math.min(160, (lx - b.px) / dt)) : 0;
        b.px = lx;
        var tiltTarget = Math.max(-22, Math.min(22, latV * 0.5));
        var gust = Math.sin(now / 1000 * b.gustF * 6.28 + b.gustPhase) * b.gustAmp;
        b.tiltV += ((tiltTarget - b.tilt) * b.spring - b.tiltV * b.damp + gust) * dt;
        b.tilt += b.tiltV * dt;
        var tilt = Math.max(-28, Math.min(28, b.tilt));
        b.el.style.opacity = op.toFixed(3);
        b.el.style.transform = 'translate3d(' + (b.x + sway).toFixed(1) + 'px,' + b.y.toFixed(1) + 'px,0) rotate(' + tilt.toFixed(1) + 'deg)';
      }
      if (running && hero.isConnected) rafId = requestAnimationFrame(tick);
    }
    /* run only while the hero is on screen. rafId is tracked and cancelled on
       every stop and before every (re)start, so a stray frame can never survive
       a bfcache freeze and run ALONGSIDE a freshly-started loop — that
       duplicate-chain accumulation across back/forward navigations was pegging
       the CPU (and holding retained page copies alive). All start/stop paths go
       through these two guarded helpers. */
    var running = false, rafId = 0, shed = false, visible = false;
    function startLoop() {
      /* visible gate: WF_HERO_START (idle thaw / bfcache restore) fires
         page-wide — without it the loop restarts while the hero is scrolled
         off-screen and the IO never re-fires (no crossing = no entry). */
      if (!visible || running || shed) return;
      running = true; last = 0; measureHero();
      cancelAnimationFrame(rafId); rafId = requestAnimationFrame(tick);
    }
    function stopLoop() { running = false; cancelAnimationFrame(rafId); }
    var io = new IntersectionObserver(function(entries) {
      /* last entry, not [0]: IO batches multiple crossings per delivery */
      visible = entries[entries.length - 1].isIntersecting;
      if (visible) startLoop(); else stopLoop();
    });
    io.observe(hero);
    WF_HERO_STOP.push(stopLoop);
    WF_HERO_START.push(startLoop);
    WF_SHED.push(function () { shed = true; stopLoop(); }); /* overload watchdog: kill drift balloons */
  })();

  /* Cloud breeze — drift engine. Left-to-right parallax (near clouds
     faster), fading near the corridor edges. Spacing logic: a faster cloud
     eases to the speed of the cloud ahead when their vertical bands overlap
     and the gap drops below MIN_GAP, and a wrapping cloud waits offscreen
     until the left edge of its band is clear — two clouds never bunch up.
     No JS / reduced motion = the static designed scene from the CSS. */
  (function() {
    var hero = document.querySelector('.walfredo-hero');
    /* Runs on mobile too (2026-07-10, post balloon-loop fix): drift is
       compositor-only transforms on 5 small SVGs, and the overload watchdog
       + visibility/bfcache stops still apply. Reduced-motion stays static. */
    if (!hero || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var SPEEDS  = { cl: 12, cl2: 6, cu: 6.5, cu2: 5.5, ru: 11, rf: 10.5, bl: 18, d1: 5, d2: 4.5, d3: 5.5, d4: 8 }; /* px/s — slightly slower */
    var FLIPPED = { cl2: 1, cu2: 1, rf: 1 };
    var FADE = 120, MIN_GAP = 110;
    var NEAR_OP = 0.6;       /* opacity >= this = a "near" (foreground) cloud */
    var NEAR_VDIST = 280;    /* near clouds this vertically close interact... */
    function nearGap() {     /* ...and keep a much wider horizontal berth */
      return Math.max(180, Math.min(300, (corridorR - corridorL) * 0.2));
    }
    var clouds = [], corridorL = 0, corridorR = 0, last = 0;

    function measure(keepProgress) {
      var heroW = hero.clientWidth;
      if (!heroW) return false;
      /* layout viewport, not innerWidth: an iOS pinch zoom shrinks innerWidth
         (and fires resize), which squeezed every cloud into a narrower corridor */
      var W = Math.min(document.documentElement.clientWidth, 1920);
      var newL = (heroW - W) / 2, newR = newL + W;
      var els = hero.querySelectorAll('.walfredo-hero__cloud');
      var next = [];
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var key = (el.className.match(/cloud--(\w+)/) || [])[1];
        if (!key || !el.offsetWidth) continue; /* hidden on this breakpoint */
        var prev = null;
        for (var j = 0; j < clouds.length; j++) if (clouds[j].el === el) prev = clouds[j];
        var c = {
          el: el, key: key,
          v: SPEEDS[key] || 10,
          w: el.offsetWidth, h: el.offsetHeight,
          top: el.offsetTop,
          staticX: el.offsetLeft,
          baseOp: parseFloat(getComputedStyle(el).opacity) || 1
        };
        c.near = c.baseOp >= NEAR_OP;
        if (keepProgress && prev) {
          var f = (prev.x - corridorL) / (corridorR - corridorL || 1);
          c.x = newL + f * (newR - newL);
          c.baseOp = prev.baseOp;
        } else {
          c.x = c.staticX;
        }
        next.push(c);
      }
      corridorL = newL; corridorR = newR; clouds = next;
      return clouds.length > 0;
    }

    function bandOverlap(a, b) {
      return a.top < b.top + b.h && a.top + a.h > b.top;
    }
    /* near clouds crowd visually even without band overlap — treat two
       big foreground clouds as interacting whenever vertically close */
    function interacts(a, b) {
      if (bandOverlap(a, b)) return true;
      return a.near && b.near &&
        Math.abs((a.top + a.h / 2) - (b.top + b.h / 2)) < NEAR_VDIST;
    }
    function gapFor(a, b) {
      return a.near && b.near ? nearGap() : MIN_GAP;
    }

    function tick(now) {
      if (!last) last = now;
      var dt = Math.min(0.1, (now - last) / 1000);
      last = now;
      clouds.sort(function(a, b) { return b.x - a.x; }); /* front first */
      for (var i = 0; i < clouds.length; i++) {
        var c = clouds[i], v = c.v;
        for (var j = i - 1; j >= 0; j--) { /* nearest interacting leader */
          if (interacts(c, clouds[j])) {
            var g = clouds[j].x - (c.x + c.w), G = gapFor(c, clouds[j]);
            if (g < G) {
              /* Brake BELOW the leader's speed, harder the deeper inside the
                 gap — so the gap re-opens and settles at G. (The old rule
                 matched the leader's speed, which froze pairs just under G:
                 they rode bunched forever and drifted right as a train.) */
              v = Math.min(v, clouds[j].vEff * (0.4 + 0.6 * Math.max(0, g) / G));
            }
            break;
          }
        }
        c.vEff = v;
        var nx = c.x + v * dt;
        if (nx > corridorR) {
          /* wrap to the left edge only once the band is clear there; a random
             setback staggers re-entries so trains don't re-form in the same
             order/phase every lap (the old fixed spawn point + fixed speeds
             re-built identical pairs, biasing the visible sky rightward) */
          var candidate = corridorL - c.w - Math.random() * 240, clear = true;
          for (var k = 0; k < clouds.length; k++) {
            var o = clouds[k];
            if (o !== c && interacts(c, o) && o.x < candidate + c.w + gapFor(c, o)) { clear = false; break; }
          }
          if (clear) {
            nx = candidate;
            /* ±15% speed jitter per lap breaks the deterministic catch-up
               pattern where the same fast cloud always caught the same slow one */
            c.v = (SPEEDS[c.key] || 10) * (0.85 + Math.random() * 0.3);
          } else {
            nx = corridorR; /* park just offscreen-right */
          }
        }
        c.x = nx;
        var op = Math.max(0, Math.min(1, (c.x + c.w - corridorL) / FADE, (corridorR - c.x) / FADE));
        c.el.style.opacity = (c.baseOp * op).toFixed(3);
        c.el.style.transform = 'translate3d(' + (c.x - c.staticX).toFixed(1) + 'px,0,0)' + (FLIPPED[c.key] ? ' scaleX(-1)' : ''); /* 3D transform = own compositor layer, no bg repaint */
      }
      if (running && hero.isConnected) rafId = requestAnimationFrame(tick);
    }

    /* drift only while the hero is on screen; measure() may fail before first
       layout (zero width) — retry while visible. rafId is cancelled on every
       stop and before every (re)start so no duplicate loop survives a bfcache
       freeze and piles up across navigations (the CPU lock). */
    var running = false, visible = false, measured = false, rafId = 0, shed = false;
    function startIfReady() {
      if (!visible || running || shed) return;
      if (!measured) {
        measured = measure(false);
        if (!measured) { setTimeout(startIfReady, 800); return; }
      }
      running = true; last = 0;
      cancelAnimationFrame(rafId); rafId = requestAnimationFrame(tick);
    }
    function stopLoop() { running = false; cancelAnimationFrame(rafId); }
    var io = new IntersectionObserver(function(entries) {
      /* last entry, not [0]: IO batches multiple crossings per delivery */
      visible = entries[entries.length - 1].isIntersecting;
      if (visible) startIfReady();
      else stopLoop();
    });
    io.observe(hero);
    /* Cloud heights are 0 until the images load AND a layout pass runs
       (at the load event itself offsetHeight is still 0) — without real
       heights, band detection is dead and the spacing rules never fire.
       Retry until every cloud has height, capped. */
    var heightTries = 0;
    function ensureHeights() {
      measure(true);
      var ok = clouds.length && clouds.every(function(c) { return c.h > 0; });
      if (!ok && ++heightTries < 20) setTimeout(ensureHeights, 400);
    }
    window.addEventListener('load', function() { requestAnimationFrame(ensureHeights); });
    window.addEventListener('resize', function() { measure(true); });
    WF_HERO_STOP.push(stopLoop);
    WF_HERO_START.push(startIfReady);
    WF_SHED.push(function () { shed = true; stopLoop(); }); /* overload watchdog: kill cloud drift */
  })();

  /* Wingsuit flyer — flies the sprite across the hero in alternating
     directions; altitude and z-plane (front of / behind logo and clouds)
     vary per pass. Bails out (leaving the static wingsuit float) when
     WAAPI is missing or reduced motion is requested. */
  (function() {
    var track = document.getElementById('walfredo-hero-flyer');
    if (!track) return;
    var flyer  = track.querySelector('.walfredo-hero__flyer');
    var sprite = track.querySelector('.walfredo-hero__flyer-sprite');
    if (!flyer || typeof flyer.animate !== 'function') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      /* reduced-motion only: drop the WAAPI flyer. Mobile now KEEPS it (user request)
         — it's hardened (rAF + cancel-on-finish) and the overload watchdog protects it. */
      track.remove();
      return;
    }
    var staticWingsuit = document.querySelector('.walfredo-hero__float-wrap--wingsuit');
    if (staticWingsuit) staticWingsuit.style.display = 'none';

    var planes = ['front', 'behind', 'mid', 'behind', 'front', 'mid'];
    var clips  = ['w1', 'w2', 'w3', 'w4', 'w5']; /* windowed clip variants (CSS) — even frame coverage */
    var pass = 0;

    /* Schedule every pass through requestAnimationFrame, never setTimeout.
       rAF fires ONLY while the browser is producing frames, so when the OS
       suspends rendering (tab hidden, or — the nasty case — the display going
       to sleep while this stays the active tab) the flyer goes fully dormant
       and spawns nothing. That matters because Chrome only auto-removes
       finished WAAPI animations during a render cycle (verified), so a
       setTimeout loop that keeps calling animate() while rendering is
       suspended piles up uncollected Animations and locks the main thread on
       wake. rAF-gating makes the flyer behave like the balloon/cloud loops:
       it pauses exactly when rendering pauses, and self-resumes with frames.
       cancel() on finish is belt-and-suspenders so nothing lingers. */
    var inView = true, pendingFly = false, flyRaf = 0, currentAnim = null;
    function canFly() { return inView && !document.hidden && track.isConnected; }
    /* rAF-based delay: waits ~ms of real frames, then flies. If frames stop
       (idle/hidden) the pending callback simply never fires until they resume;
       if the hero scrolls out of view it parks as pendingFly for resume(). */
    function scheduleFly(ms) {
      cancelAnimationFrame(flyRaf);
      var start = null;
      function wait(now) {
        if (start === null) start = now;
        if (!canFly()) { pendingFly = true; return; }
        if (now - start >= ms) { fly(); return; }
        flyRaf = requestAnimationFrame(wait);
      }
      flyRaf = requestAnimationFrame(wait);
    }
    function resume() {
      if (pendingFly && canFly()) { pendingFly = false; scheduleFly(400); }
    }
    var io = new IntersectionObserver(function(entries) {
      /* last entry, not [0]: IO batches multiple crossings per delivery */
      inView = entries[entries.length - 1].isIntersecting;
      resume();
    });
    io.observe(track);
    document.addEventListener('visibilitychange', resume);


    function fly() {
      if (!canFly()) { pendingFly = true; return; }
      var trackW = track.clientWidth;
      var trackH = track.clientHeight;
      var flyerW = flyer.offsetWidth;
      var flyerH = flyer.offsetHeight;
      if (!trackW || !flyerW) { scheduleFly(1000); return; }
      var goingRight = pass % 2 === 0;
      track.className = 'walfredo-hero__flyer-track walfredo-hero__flyer-track--' + planes[pass % planes.length];
      sprite.style.transform = goingRight ? 'scaleX(-1)' : 'none'; /* art faces left */

      /* Random clip window: ping-pong one 9-frame slice of the strip (or the
         whole video) — windows overlap so every part of the sheet shows up
         in ~2 of 5 passes. Alternate playback loops any window seamlessly.
         Pure CSS steps() does the stepping. */
      var clip = clips[Math.floor(Math.random() * clips.length)];
      sprite.className = 'walfredo-hero__flyer-sprite walfredo-hero__flyer-sprite--' + clip;
      var fromX = goingRight ? -flyerW : trackW;
      var toX   = goingRight ? trackW  : -flyerW;

      /* Vertical path = cubic bezier inside a safe band; x advances linearly. */
      var band = Math.max(60, trackH - flyerH - 24);
      function anchorY() { return 12 + Math.random() * band * 0.55; }
      function ctrlY(near) {
        var y = near + (Math.random() * 2 - 1) * band * 0.6;
        return Math.max(8, Math.min(band, y));
      }
      var y0 = anchorY(), y3 = anchorY();
      var y1 = ctrlY(y0), y2 = ctrlY(y3);

      /* Slow toward/away tilt (rotateX), biased a touch toward his back foot. */
      var tiltAmp    = 5 + Math.random() * 4;
      var tiltCycles = 1 + Math.random();
      var tiltPhase  = Math.random() * Math.PI * 2;

      var N = 24, frames = [];
      for (var i = 0; i <= N; i++) {
        var t = i / N, u = 1 - t;
        var x = fromX + (toX - fromX) * t;
        var y = u*u*u*y0 + 3*u*u*t*y1 + 3*u*t*t*y2 + t*t*t*y3;
        /* bank into the curve: tangent angle relative to travel direction */
        var dy = 3*u*u*(y1 - y0) + 6*u*t*(y2 - y1) + 3*t*t*(y3 - y2);
        var bank = Math.atan2(dy, toX - fromX) * 180 / Math.PI;
        if (bank >  90) bank -= 180;
        if (bank < -90) bank += 180;
        bank = Math.max(-14, Math.min(14, bank * 0.45));
        var away = 2.5 + tiltAmp * Math.sin(tiltPhase + t * Math.PI * 2 * tiltCycles);
        frames.push({
          transform: 'translate3d(' + Math.round(x) + 'px,' + Math.round(y) + 'px,0)'
            + ' perspective(600px) rotateX(' + away.toFixed(1) + 'deg)'
            + ' rotate(' + bank.toFixed(1) + 'deg)',
          offset: t
        });
      }
      var desktop = window.matchMedia('(min-width: 769px)').matches;
      var dur = desktop ? 4400 + Math.random() * 1650 : 3000 + Math.random() * 1500; /* desktop slowed 10% (2026-07-22); mobile ~25% faster (0.75x) per request */
      var anim = flyer.animate(frames, { duration: dur, easing: 'linear' });
      currentAnim = anim;
      anim.onfinish = function() {
        anim.cancel(); /* deterministic removal — never wait on the render cycle */
        currentAnim = null;
        pass++;
        if (canFly()) scheduleFly(500 + Math.random() * 1500);
        else pendingFly = true;
      };
    }
    /* bfcache: cancel the live flight + pending schedule so the frozen page
       carries no running WAAPI animation; resume() relaunches on restore. */
    WF_HERO_STOP.push(function () {
      cancelAnimationFrame(flyRaf);
      if (currentAnim) { try { currentAnim.cancel(); } catch (e) {} currentAnim = null; }
      pendingFly = true;
    });
    WF_HERO_START.push(function () { resume(); });
    WF_SHED.push(function () { /* overload watchdog: kill the WAAPI flyer for good */
      inView = false; cancelAnimationFrame(flyRaf);
      if (currentAnim) { try { currentAnim.cancel(); } catch (e) {} currentAnim = null; }
      if (track && track.parentNode) track.remove();
    });
    fly();
  })();

  /* Hover pops made the float wraps pointer-events:auto, which lets Firefox
     natively drag the cast/cloud images (it ignores -webkit-user-drag).
     One delegated guard covers every image in the hero. */
  (function () {
    var hero = document.querySelector('.walfredo-hero');
    if (hero) hero.addEventListener('dragstart', function (e) { e.preventDefault(); });
  })();

  /* ── Overload watchdog v4: lag shed + runtime backstop + flight recorder ──
     v3 was written while the hard-lock cause was still unknown, so it bounded
     runtime aggressively on a thermal-creep THEORY. The actual cause was found
     and fixed (float fixed-point infinite loop in the balloon spawn, both hero
     and PDP copies), so v4 keeps only the evidence-driven parts:

     1. LAG SHED (safety net): a 500ms self-scheduling beat. Sustained lag
        (4 consecutive beats each >700ms late) OR one catastrophic stall (a
        single beat 5s–120s late while visible) sheds the heavy ambient movers
        (WAAPI flyer, drift balloons, cloud drift, extra sky-cast) via WF_SHED
        + .wf-hero-shed. Gaps spanning a hidden tab, an idle-frozen hero, a
        bfcache restore, or system sleep (>120s) are measurement artifacts,
        not lag — those reset the window instead of shedding. This is the real
        net: it fires on measured distress, not on a clock, so it still covers
        weak/hot GPUs we can't reproduce.

     2. RUNTIME BACKSTOP (desktop only): a single soft shed after 20 cumulative
        minutes of visible, non-idle animation in one pageview. Far past any
        real viewing session — it exists only so a pathological tab left open
        for a long time can't hold an unbounded standing load. The v3 hard
        "rest" (permanent full stop at 10 minutes, reload-only recovery) is
        GONE: it punished engaged visitors for a bug that no longer exists.

     3. FLIGHT RECORDER: every ~5s persist a snapshot (ring buffer of 8) to
        localStorage['wf_fdr'] — timestamp, cumulative runtime, last beat
        gap, idle/shed flags, visibility, count of running animations.
        After any future lock, read the buffer: the last record is the
        hero's state ≤5s before death. Post-mortems on data, not anecdotes.

     Fully try/caught: worst case is "some animations stop", never a broken
     page. localStorage['wf_hero_shed_at'] records why a shed fired. */
  (function () {
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; /* runs on mobile too, to protect the mobile flyer */
      var BEAT = 500, laggy = 0, shedDone = false, last = 0, lastGap = 0, runtime = 0, beats = 0;
      var GOVERN = window.matchMedia('(min-width: 769px)').matches;
      var SHED_AFTER = 1200000;
      var SID = Math.random().toString(36).slice(2, 6); /* per-pageview id — wf_fdr is shared across tabs, sid tells writers apart */
      /* Telemetry is OPT-IN: set localStorage.wf_debug = '1' to record the
         flight-recorder ring buffer + crash archive. Production visitors get
         no storage writes; the shed/governor SAFETY logic below always runs. */
      var WF_DEBUG = false;
      try { WF_DEBUG = localStorage.getItem('wf_debug') === '1'; } catch (e0) {}
      function shedNow(why) {
        if (shedDone) return;
        shedDone = true;
        for (var i = 0; i < WF_SHED.length; i++) { try { WF_SHED[i](); } catch (e) {} }
        try { document.documentElement.classList.add('wf-hero-shed'); } catch (e) {}
        if (WF_DEBUG) { try { localStorage.setItem('wf_hero_shed_at', new Date().toISOString() + ' ' + why); } catch (e) {} }
      }
      /* A gap spanning a visibility flip or bfcache restore is not lag —
         drop the measurement window instead of mis-reading it. */
      function resetGapWindow() { last = 0; laggy = 0; }
      document.addEventListener('visibilitychange', resetGapWindow);
      window.addEventListener('pageshow', resetGapWindow);
      function writeFdr(extra) {
        if (!WF_DEBUG) return;
        try {
          var recs;
          try { recs = JSON.parse(localStorage.getItem('wf_fdr') || '[]'); } catch (e2) { recs = []; }
          if (!recs || typeof recs.push !== 'function') recs = [];
          extra.sid = SID;
          recs.push(extra);
          while (recs.length > 12) recs.shift();
          localStorage.setItem('wf_fdr', JSON.stringify(recs));
        } catch (e3) {}
      }
      function beat() {
        var now = (window.performance && performance.now) ? performance.now() : Date.now();
        if (last && !document.hidden && !WF_IDLE_FROZEN) {
          var gap = now - last;
          lastGap = Math.round(gap);
          if (gap > 120000) { laggy = 0; } /* display/system sleep, not lag */
          else if (gap > 5000) { laggy = 0; shedNow('stall ' + Math.round(gap) + 'ms'); }
          else if (gap > BEAT + 700) { laggy++; if (laggy >= 4) { laggy = 0; shedNow('lag'); } }
          else { laggy = 0; }
          if (GOVERN && !shedDone && gap < 120000) {
            runtime += Math.min(gap, 1500);
            if (runtime > SHED_AFTER) shedNow('runtime ' + Math.round(runtime / 1000) + 's');
          }
        }
        last = now;
        beats++;
        if (beats % 10 === 0) {
          var running = -1;
          try {
            if (document.getAnimations) {
              running = 0;
              var anims = document.getAnimations();
              for (var a = 0; a < anims.length; a++) { if (anims[a].playState === 'running') running++; }
            }
          } catch (e4) {}
          writeFdr({ t: new Date().toISOString(), up: Math.round(runtime / 1000), gap: lastGap, idle: !!WF_IDLE_FROZEN, shed: shedDone, vis: !document.hidden, anims: running });
        }
        setTimeout(beat, BEAT);
      }
      /* Boot forensics: a session that ended gracefully (nav/close/bfcache)
         has a {bye} marker as its last record — pagehide can't run during a
         hard lock or force-kill. So a previous tail WITHOUT one (and with
         more than just a boot marker) means the page died hard: archive it
         to wf_fdr_crash, which survives reloads and is only replaced by the
         next crash. The live buffer restarts fresh each load. */
      try {
        if (!WF_DEBUG) throw 0; /* opt-in only — skip crash-archive housekeeping */
        var prev;
        try { prev = JSON.parse(localStorage.getItem('wf_fdr') || '[]'); } catch (e6) { prev = []; }
        if (prev && prev.length) {
          var tail = prev[prev.length - 1];
          if (tail && !tail.bye && !tail.boot) {
            localStorage.setItem('wf_fdr_crash', JSON.stringify(prev));
          }
        }
        localStorage.removeItem('wf_fdr');
      } catch (e7) {}
      window.addEventListener('pagehide', function () { writeFdr({ t: new Date().toISOString(), bye: 1 }); });
      /* Boot marker: one record per load, so post-mortems can tell reloads
         (and stale-code tabs) apart. */
      writeFdr({ t: new Date().toISOString(), boot: 3 });
      setTimeout(beat, BEAT);
    } catch (e) {}
  })();

  /* ── Idle quiesce ──
     The heavy desktop hero (7 rAF cloud-drift + balloon-drift loops, the WAAPI
     flyer, and ~20 CSS sprite animations) must never run UNATTENDED. The drift
     loops already pause when the hero scrolls off-screen (IntersectionObserver)
     or the tab is hidden (visibilitychange/bfcache) — but a hero sitting ON
     screen in the FOCUSED tab with no viewer keeps compositing indefinitely, and
     a laptop left open on this page burns battery and spins fans for nobody.
     So after IDLE_MS with no pointer/scroll/key/touch we freeze the WHOLE hero
     to a static poster — stop every loop (WF_HERO_STOP) + pause all remaining
     CSS animation (.wf-hero-idle) — and resume instantly on the first activity.
     The hero is also already static before the display ever sleeps (nothing to
     flood the main thread on wake).

     IDLE_MS is 5 minutes, NOT the old 60s. 60s was set when the hard lock was
     undiagnosed and every second of animation looked like risk; the cause is
     now known and fixed (balloon-spawn infinite loop), and 60s was killing the
     hero while people were still watching it. 5 min only catches real
     walk-aways. Skipped in CALM mode — phones already run static. */
  (function () {
    try {
      if (WF_CALM) return;
      var IDLE_MS = 300000, idleTimer = 0, frozen = false;
      function freeze() {
        if (frozen) return;
        frozen = true;
        WF_IDLE_FROZEN = true; /* watchdog: skip gap/runtime accounting while frozen */
        for (var i = 0; i < WF_HERO_STOP.length; i++) { try { WF_HERO_STOP[i](); } catch (e) {} }
        try { document.documentElement.classList.add('wf-hero-idle'); } catch (e) {}
      }
      function thaw() {
        if (frozen) {
          frozen = false;
          WF_IDLE_FROZEN = false;
          try { document.documentElement.classList.remove('wf-hero-idle'); } catch (e) {}
          for (var i = 0; i < WF_HERO_START.length; i++) { try { WF_HERO_START[i](); } catch (e) {} }
        }
      }
      function activity() { thaw(); clearTimeout(idleTimer); idleTimer = setTimeout(freeze, IDLE_MS); }
      var evs = ['pointermove', 'pointerdown', 'keydown', 'wheel', 'scroll', 'touchstart'];
      for (var e = 0; e < evs.length; e++) {
        window.addEventListener(evs[e], activity, { passive: true });
      }
      /* A hidden tab is idle by definition; freeze at once (and let the bfcache
         handlers do their thing too). Becoming visible counts as activity. */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) freeze(); else activity();
      });
      /* bfcache restore while idle-frozen: the global pageshow handler restarts
         the rAF loops, but `frozen` + .wf-hero-idle would keep the CSS paused
         (loops burning CPU behind a frozen-looking hero until the first mouse
         move). Reconcile: a restore counts as activity — thaw + re-arm. */
      window.addEventListener('pageshow', function (e) { if (e.persisted) activity(); });
      activity(); /* arm the idle timer on load */
    } catch (e) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["walfredo-return-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  const form = document.querySelector('[data-return-form]');
  if (!form) return;

  const id = form.dataset.returnForm;

  // The reason placeholder has value="" so the empty check rejects it
  const FIELDS = [
    { suffix: 'name', msg: 'Please enter your name.' },
    { suffix: 'email', msg: 'Please enter a valid email address.' },
    { suffix: 'order', msg: 'Please enter your order number.' },
    { suffix: 'reason', msg: 'Please choose a reason.' },
    { suffix: 'body', msg: 'Please tell us what happened.' },
  ];

  function getEl(field)  { return document.getElementById(id + '-' + field.suffix); }
  function getErr(field) { return document.getElementById(id + '-' + field.suffix + '-error'); }

  function isValid(field) {
    const el = getEl(field);
    if (!el) return true;
    if (el.type === 'email') return el.value.trim() !== '' && el.checkValidity();
    return el.value.trim() !== '';
  }

  function showError(field) {
    const el = getEl(field);
    const err = getErr(field);
    if (!el || !err) return;
    err.textContent = field.msg;
    el.setAttribute('aria-invalid', 'true');
  }

  function clearError(field) {
    const el = getEl(field);
    const err = getErr(field);
    if (!el || !err) return;
    err.textContent = '';
    el.removeAttribute('aria-invalid');
  }

  // Photo callout: only relevant when the issue is visible (print/damage/wrong item)
  const PHOTO_REASONS = ['defect', 'wrong_item', 'damaged'];
  const reasonSelect = document.getElementById(id + '-reason');
  const photoCallout = form.querySelector('[data-photo-callout]');

  function syncPhotoCallout() {
    if (!reasonSelect || !photoCallout) return;
    photoCallout.hidden = PHOTO_REASONS.indexOf(reasonSelect.value) === -1;
  }

  if (reasonSelect) reasonSelect.addEventListener('change', syncPhotoCallout);
  syncPhotoCallout();

  FIELDS.forEach(function (field) {
    const el = getEl(field);
    if (!el) return;
    el.addEventListener('blur', function () {
      if (!isValid(field)) showError(field); else clearError(field);
    });
    el.addEventListener('input', function () { clearError(field); });
  });

  form.addEventListener('submit', function (e) {
    let firstInvalid = null;
    FIELDS.forEach(function (field) {
      if (!isValid(field)) {
        showError(field);
        if (!firstInvalid) firstInvalid = getEl(field);
      } else {
        clearError(field);
      }
    });
    if (firstInvalid) {
      e.preventDefault();
      // Also stop the event from reaching document: Shopify's captcha
      // bootstrap listens there and force-resubmits /contact forms via
      // form.submit() without checking defaultPrevented.
      e.stopPropagation();
      firstInvalid.focus();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
